import React, {Component} from 'react';
import "./App.css";
import Bild from "./Bilder/Leben.jpg"


class Aerzte extends Component {


	UNSAFE_componentWillMount(){
		window.scrollTo(0,0);
	}

render() {	
  return (	

	<div className="homeApp">

	
	
	<div className="contentHome" >	

		<h2>Lassen wir jetzt die Mediziner<br/>sprechen</h2>
		<p className="Einleitung">                   
    		Nur eine kleine Auswahl als Anregung zum Weiterstöbern.       
    	</p>
		
		<div className="Ein">
		<p>
		<h3>Die führenden Wissenschaftler stehen auf</h3>
		<a className="videoText" rel="noopener" href="https://www.bitchute.com/video/DrFeKvc7LrTU/" target="_blank" >
				Die Great Barrington Erklärung
				</a>
				<br/>kommentiert von Dr. Bonelli
				<br/><br/>
				<a className="videoText" rel="noopener" href="https://gbdeclaration.org" target="_blank" >
				Die Great Barrington Erklärung 
				</a>
				<br/>Original
		</p>
		<br/>	
			<a className="videoText" rel="noopener"  href="https://auf1.tv/elsa-auf1/prof-sucharit-bhakdi-wenn-wir-jetzt-keine-angst-bekommen-grenzt-das-an-dummheit/" target="_blank" >
			Prof. Sucharit Bhakdi: "Wenn wir jetzt keine Angst bekommen, grenzt das an Dummheit!" 31.05.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=5gdiDUY0Ors" target="_blank" >
			Lauterbachs Lügen: Eine kurze Geschichte des Impfbetruges. Gast: Dr. Kay Klapproth 19.04.2023
			</a>
			<a className="videoText"  rel="noopener" href="https://legitim.ch/peer-review-studie-long-covid-ist-fake-menschen-die-denken-sie-haetten-es-sind-einfach-einsam-und-ausser-form/" target="_blank" >
			Peer-Review-Studie: LONG COVID IST FAKE 13.04.2023
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=RbqKkHb9I2c" target="_blank" >
			PK München - Statement zur Labordiagnostik 23.03.2023
			</a>
			<a className="videoText"  rel="noopener" href="https://apolut.net/sucharit-bhakdi-bedrueckende-nachrichten/" target="_blank" >
				Sucharit Bhakdi – Bedrückende Nachrichten 17.05.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=IIHDPGP4XhQ" target="_blank" >
				Pandemie: Strategie und Impfpflicht 16.01.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://t.me/Haintz/18954" target="_blank" >
				Anthony Fauci bestätigt, dass der PCR test keine lebenden Viren nachweisen kann. 04.01.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://rumble.com/vr4emv-interview-paul-brandenburg.html" target="_blank" >
				"Faschistischer Unsinn" - Dr. Paul Brandenburg über die Corona-Maßnahmen 22.12.2021
			</a>		
			<a className="videoText"  rel="noopener" href="https://pressecop24.com/corona-wahnsinn-immer-mehr-aerzten-reicht-es-und-sie-beteiligen-sich-am-widerstand/" target="_blank" >
				Immer mehr Ärzten reicht es und sie beteiligen sich am Widerstand! 19.12.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=4KD_3igxz0k" target="_blank" >
						Sucharit Bhakdi erklärt die Wirkungen der neuartigen Impfungen 03.08.2021
			</a>
			<a className="videoText" rel="noopener" href="https://www.servustv.com/videos/aa-27juub3a91w11/" target="_blank" >
				Corona auf der suche nach der Wahrheit	09.05.2021
			</a>			
			<a className="videoText" rel="noopener" href="https://www.youtube.com/watch?v=Inf_nK_PkGU&t=2308s" target="_blank" >
				Dr. Prof. Dr. Karina Reiss	17.07.2020
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=UXsovK5qWEU" target="_blank" >
				Prof. Dr. Michael Klundt - Bundestagsanhörung
			</a>
			<a className="videoText" rel="noopener" href="https://www.youtube.com/watch?v=U36qjVfwmPo" target="_blank" >
				Der Staatsvirus	13.05.2021
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=L80Vp2Rd4mg" target="_blank" >
					„Mund-Desinfektion hätte Tausende gerettet“ Prof. Dr. Klaus-Dieter Zastrow  02.07.2021
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=JaRhU6yaoW8" target="_blank" >
				Oberarzt und Intensivmediziner Herr Zehentner - bayerisch
			</a>
			<a className="videoText" rel="noopener" href="https://www.youtube.com/watch?v=ZX9QdZL4G-s" target="_blank" >
				Sven Armbrust - Chefarzt Kinder & Jugendmedizin   18.03.2021
			</a>			
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=_fVpnRHe6Z8&feature=youtu.be" target="_blank" >
				Kritik am Corona-Inzidenzwert: „Diese Zahlen sind gewürfelt!"<br/>
				Hygiene-Professor Zastrow 05.01.2021
			</a>	
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=l866wsIs9N8" target="_blank" >
				Wissenschaft widerlegt den Nutzen vom LOCKDOWN! 14.01.2021
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=lcbBOtYiJV0" target="_blank" >
						Dr. Bonelli - Kinder	23.03.2021
			</a>			
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=O0iQo-pmh8c" target="_blank" >
				Noch nie so viele Patienten mit Depressionen 28.01.2021
			</a>											
			<a className="videoText" rel="noopener"  href="https://www.bitchute.com/video/EhlCwJLHB24r/" target="_blank" >
				Dr. Bodo Schiffmann 139	14.09.2020
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=s2xbM7UOhN4" target="_blank" >
				Neurologin Margareta Griesz Brisson
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=QD1VSQDUGa0" target="_blank" >
				Infektiologin Petra Apfalter 06.10.2020
			</a>			
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=blcESfa0V1w" target="_blank" >
				PCR-Test Prof. Dr. Dr. Martin Haditsch
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=BxSCD5GjLLM&t=128s" target="_blank" >
				Prof. DDr. Christian Schubert   24.10.2020
			</a>			

			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=JteYXEodL6Q" target="_blank" >
				Heiko Schöning	09.08.2020
			</a>

			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=Tbb0kr8ANJk"  target="_blank">
				Prof. Reis Prof. Bhakdi - 1. Teil	11.09.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=1yxtLmw1Zik" target="_blank" >
				Prof. Reis Prof. Bhakdi - 2. Teil	11.09.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=CVkdG40Rl2Y&t=157s" target="_blank" >
				Dr. Krämer Doc Ulli 	31.05.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=gCqJK7SiV_Y" target="_blank" >
				Frau Dr. med. Gerlind Läger, Internistin
			</a>			
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=0JcVglSdQ-c" target="_blank" >
				Dr. Claus Köhnlein  18.09.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=PnNBqGyh6Tc&pbjreload=101" target="_blank" >
				Dr. Bonelli  13.06.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=_cNAmSjWzOY" target="_blank" >
				Prof. Dr. Dr. Martin Haditsch  06.09.2020
			</a>
			
			
		</div>
	</div>

	
	
	<img src={Bild} className="K11" alt="Kinder1" />

</div>
	
	 
  );
};
};

export default Aerzte;
